import { Navigate } from 'react-router-dom'
import { FeatureTogglesComponent } from 'app/components/feature-toggles/FeatureTogglesComponent'
import { useUser } from 'app/utils'

export default function FeatureToggles(): React.ReactElement | null {
  const user = useUser()

  if (!user) return null

  // Super-user guard — must run before the data hook mounts so non-super users
  // never fire the super-only featureToggles query (which returns Forbidden).
  if (user.type !== `super`) {
    return <Navigate to="/" replace />
  }

  return <FeatureTogglesComponent />
}
